// extracted by mini-css-extract-plugin
export var equalColumn = "_gn-0";